import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@node-space/hooks'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getProfile } from 'services/AuthService'
import { isTestEnvironment } from 'utils/environment'

export const useProfileQuery = (isEnabled = true) => {
  const { isAuthed } = useAuth()
  const location = useLocation()

  return useQuery(reactQueryKeys.profile(), getProfile, {
    cacheTime: Infinity,
    enabled: isTestEnvironment || (isAuthed && isEnabled),
    onError: (error: unknown) => {
      logSentryError('Error: useProfileQuery', error, {
        location,
      })
    },
  })
}
